export const paymentMethodKeys = {
  all: (storeId: string) => ['stores', storeId, 'payment-methods'] as const,
  list: (storeId: string) => [...paymentMethodKeys.all(storeId), 'list'] as const,
};
